			let visitorId
			if (localStorage.getItem('visitorId') !== null) {
				visitorId = localStorage.getItem('visitorId')
			} else {
				FingerprintJS.load().then(fp => {
				  fp.get().then(result => {
					visitorId = result.visitorId;
					localStorage.setItem('visitorId', visitorId);
				  });
				});
			}
		
			
		
			Vue.filter('TunisianDate', function (value) {
				if (!value) return ''
				return new Intl.DateTimeFormat('ar-TN-u-ca-gregory-nu-latn', {year : 'numeric', month: 'long', day: 'numeric'}).format(new Date(value))
			})
			
			Vue.filter('NumberMonths', function(value) {
				if (!value) return ''
				let n = new Intl.PluralRules('ar-TN').select(value)
				switch(n) {
					case "one":
						return 'شهر'
					break;
					case "two":
						return 'شهرين'
					break;
					case "few":
						return `${value} أشهر`
					break;
					case "many":
						return `${value} شهرا`
					break;
					case "other":
						return `${value}`
					break;
				}
			})
			
			new Vue({
				el: '.container',
				data: {
					pname: '',
					pcin: '',
					pcind: '',
					paddr: '',
					rname: '',
					rcin: '',
					rcind: '',
					raddr: '',
					addr: '',
					period: '',
					sdate: '',
					fdate: '',
					rent: '',
					warranty: ''
				},
				mounted() {
					if (localStorage.pname) {
					  this.pname = localStorage.pname;
					}
					if (localStorage.pcin) {
					  this.pcin = localStorage.pcin;
					}
					if (localStorage.pcind) {
					  this.pcind = localStorage.pcind;
					}
					if (localStorage.paddr) {
					  this.paddr = localStorage.paddr;
					}
					if (localStorage.rname) {
					  this.rname = localStorage.rname;
					}
					if (localStorage.rcin) {
					  this.rcin = localStorage.rcin;
					}
					if (localStorage.rcind) {
					  this.rcind = localStorage.rcind;
					}
					if (localStorage.raddr) {
					  this.raddr = localStorage.raddr;
					}
					if (localStorage.addr) {
					  this.addr = localStorage.addr;
					}
					if (localStorage.period) {
					  this.period = localStorage.period;
					}
					if (localStorage.sdate) {
					  this.sdate = localStorage.sdate;
					}
					if (localStorage.fdate) {
					  this.fdate = localStorage.fdate;
					}
					if (localStorage.rent) {
					  this.rent = localStorage.rent;
					}
					if (localStorage.warranty) {
					  this.warranty = localStorage.warranty;
					}
				},
				watch: {
					pname(newName) {
					  localStorage.pname = newName;
					},
					pcin(newName) {
					  localStorage.pcin = newName;
					},
					pcind(newName) {
					  localStorage.pcind = newName;
					},
					paddr(newName) {
					  localStorage.paddr = newName;
					},
					rname(newName) {
					  localStorage.rname = newName;
					},
					rcin(newName) {
					  localStorage.rcin = newName;
					},
					rcind(newName) {
					  localStorage.rcind = newName;
					},
					raddr(newName) {
					  localStorage.raddr = newName;
					},
					addr(newName) {
					  localStorage.addr = newName;
					},
					period(newName) {
					  localStorage.period = newName;
					},
					sdate(newName) {
					  localStorage.sdate = newName;
					  if(!(isNaN(Date.parse(this.sdate)))){
						if(!(isNaN(Date.parse(this.fdate)))){
							this.period = this.diff_months(new Date(this.fdate), new Date(this.sdate))
						}
					  }
					},
					fdate(newName) {
					  localStorage.fdate = newName;
					  if(!(isNaN(Date.parse(this.sdate)))){
						if(!(isNaN(Date.parse(this.fdate)))){
							this.period = this.diff_months(new Date(this.fdate), new Date(this.sdate))
						}
					  }
					},
					rent(newName) {
					  localStorage.rent = newName;
					},
					warranty(newName) {
					  localStorage.warranty = newName;
					}
				},
				methods : {
					diff_months(dt2, dt1){
						let months;
						months = (dt2.getFullYear() - dt1.getFullYear()) * 12;
						months -= dt1.getMonth();
						months += dt2.getMonth();
						return months + 1
					}
				}
			})
			
			function myFunction() {
				window.print()
				if(localStorage.addr != undefined){
						let savedData = {}
						savedData.data =  { 
							addr: localStorage.addr,
							period: localStorage.period,
							rent: localStorage.rent,
							warranty:  localStorage.warranty,
							visitorId: localStorage.visitorId
						}
						let objFinal = JSON.stringify(savedData);
						
						
						fetch("https://mczen-technologies.com/fintech/api/collections/save/Contracts", {
							"method": "POST",
							"headers": {
								"content-type": "application/json",
								"cockpit-token": "81150b7a92a4fc2f4da110f723434e"
							},
							"body": objFinal
						})
						.then(response => {
							console.log(response);
						})
						.catch(err => {
							console.error(err);
						});
						
				}
			}